import React, { PropsWithChildren } from 'react';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import styled from 'styled-components';
import dogAnimationData from './animationData/error-dog.json';
import coffeeSpilledAnimationData from './animationData/error-coffee-spilled.json';

type Props = PropsWithChildren<Record<string, unknown>>;

type State = {
    hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: any) {
        this.setState({ hasError: true });
        toast.error(error.message, { autoClose: false });
    }

    handleRetry = () => {
        this.setState({ hasError: false });
    };

    render() {
        const animationData = Math.random() > 0.25 ? dogAnimationData : coffeeSpilledAnimationData;
        if (this.state.hasError) {
            return (
                <Container>
                    <Title>Une erreur inopinée est survenue</Title>
                    <Lottie animationData={animationData} loop style={{ width: 400, height: 400 }} />
                    <RetryButton onClick={this.handleRetry}>Réessayer</RetryButton>
                </Container>
            );
        }
        return this.props.children;
    }
}

const Container = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Title = styled.span`
    font-size: 42px;
    font-weight: 800;
    color: ${({ theme }) => theme.textColor};
`;

const RetryButton = styled.button`
    margin-top: 24px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    background-color: ${({ theme }) => theme.ctaPrimaryColor};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.85;
    }
`;
